import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-h2h-statistics" }
const _hoisted_2 = { class: "as-h2h-statistics__head" }
const _hoisted_3 = { class: "as-h2h-statistics__body" }
const _hoisted_4 = { class: "as-vs" }
const _hoisted_5 = { class: "as-vs__tile" }
const _hoisted_6 = { class: "as-vs__line" }
const _hoisted_7 = { class: "as-vs-line-item" }
const _hoisted_8 = { class: "as-result" }
const _hoisted_9 = { class: "as-result-body" }
const _hoisted_10 = { class: "as-result-item as-result-item__win" }
const _hoisted_11 = { class: "as-result-item as-result-item__draw" }
const _hoisted_12 = { class: "as-result-item as-result-item__loss" }
const _hoisted_13 = { class: "as-statics-list" }
const _hoisted_14 = { class: "as-previous-results" }
const _hoisted_15 = {
  key: 0,
  class: "as-previous-results__body"
}
const _hoisted_16 = { class: "as-previous-result-item" }
const _hoisted_17 = { class: "as-previous-result-item__date" }
const _hoisted_18 = { class: "as-previous-result-item__info" }
const _hoisted_19 = { class: "as-item-info" }
const _hoisted_20 = { class: "as-home" }
const _hoisted_21 = { class: "as-score" }
const _hoisted_22 = { class: "as-scoreboard" }
const _hoisted_23 = { class: "as-match-item__vs as-t_vs_num" }
const _hoisted_24 = { class: "as-away" }

import IconH2HStatistics from '~src/components/icons/foot_stats/IconH2HStatistics.vue';
    import FootballTeamItem from '../FootballTeamItem.vue';
    import type { IMatch } from '~src/interfaces';
    import StaticsItem from '../final_score/StaticsItem.vue';
    import type { IFootyStats, IPreviousMatchId, ITeam } from '~src/interfaces/footystats';
    import { formatLocalTime } from "~src/helpers/CommonHelper";
    import { onMounted, ref } from 'vue';
    import PlayerItem from './PlayerItem.vue';

    
const __default__ = {};

interface Props{
        match: IMatch;
        footyStats: IFootyStats | null
    }
    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2HStatistics',
  props: {
    match: {},
    footyStats: {}
  },
  setup(__props: any) {

    const props = __props
    const getValue = (mode = '', is_string = false) => {
        let _number = 0;
        let _string = '';
        const __h2h = props.footyStats?.h2h

        if(!__h2h){
            return is_string ? _string : _number;
        }
        const __total = __h2h.previous_matches_results.totalMatches;
        switch(mode){
            case 'over_15':
                _number = __h2h.betting_stats.over15Percentage
                break;
            case 'over_25':
                _number = __h2h.betting_stats.over25Percentage
                break;
            case 'over_35':
                _number = __h2h.betting_stats.over35Percentage
                break;
            case 'btts':
                _number = __h2h.betting_stats.bttsPercentage
                break;

            case 'sub_over_15':
                _string  = `${__h2h.betting_stats.over15}/${__total} trận`
                break;
            case 'sub_over_25':
                _string  = `${__h2h.betting_stats.over25}/${__total} trận`
                break;
            case 'sub_over_35':
                _string  = `${__h2h.betting_stats.over35}/${__total} trận`
                break;
            case 'sub_btts':
                _string  = `${__h2h.betting_stats.btts}/${__total} trận`
                break;
        }

        return is_string ? _string : _number;
    }
    const previous_matches = ref<IPreviousMatchId[]>(props?.footyStats?.h2h?.previous_matches_ids || [])
    onMounted(async () => {
        if (props?.footyStats?.h2h?.previous_matches_ids) {
            const previous_matches_ids = props?.footyStats?.h2h?.previous_matches_ids;
            const teams = props?.footyStats?.list_teams ?? [];

            previous_matches.value = previous_matches_ids.map((prev: IPreviousMatchId) => {
                let team_a = teams.find((p: ITeam) => p.id === prev.team_a_id);
                let team_b = teams.find((p: ITeam) => p.id === prev.team_b_id);
                return {
                    ...prev,
                    team_a,
                    team_b
                };
            });
        }
    });

    const calculatorAVG = (num_1: number, num_2: number, num_3: number, mode: number = 1) => {
        const _total = (num_1 + num_2 + num_3)
        let _number = num_1;
        if(mode == 2){
            _number = num_2;
        }else if(mode == 3){
            _number = num_3
        }

        if(_total > 0){
            return Math.round((_number / _total) * 100)
        }

        return 0;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconH2HStatistics),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " Thống kê đối đầu ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modifyClass: "as-vertical",
        mode: "h2h",
        showName: false,
        showOnlyName: true,
        showStatus: false,
        showResult: false
      }, null, 8, ["footyStats", "match"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.footyStats?.h2h?.previous_matches_results?.totalMatches), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Trận đấu", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "as-vs-line-item__win",
              style: _normalizeStyle({
                            width: `${ calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0) }%`
                        })
            }, null, 4),
            _createElementVNode("div", {
              class: "as-vs-line-item__draw",
              style: _normalizeStyle({
                            width: `${ calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 2) }%`
                        })
            }, null, 4),
            _createElementVNode("div", {
              class: "as-vs-line-item__loss",
              style: _normalizeStyle({
                            width: `${ calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 3) }%`
                            })
            }, null, 4)
          ])
        ])
      ]),
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modeTeam: "as-away",
        modifyClass: "as-vertical",
        mode: "h2h",
        showName: false,
        showOnlyName: true,
        showStatus: false,
        showResult: false
      }, null, 8, ["footyStats", "match"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0) + " Thắng ", 1),
          _createElementVNode("span", null, " (" + _toDisplayString(calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0)) + "%) ", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0) + " Hoà ", 1),
          _createElementVNode("span", null, " (" + _toDisplayString(calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 2)) + "%) ", 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString(_ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0) + " Thắng ", 1),
          _createElementVNode("span", null, " (" + _toDisplayString(calculatorAVG(_ctx.footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.draw ?? 0, _ctx.footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 3)) + "%) ", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(StaticsItem, {
        title: "Trên 1.5",
        mainValue: getValue('over_15'),
        subTitle: getValue('sub_over_15', true),
        classModify: "as-green"
      }, null, 8, ["mainValue", "subTitle"]),
      _createVNode(StaticsItem, {
        title: "Trên 2.5",
        mainValue: getValue('over_25'),
        subTitle: getValue('sub_over_25', true),
        classModify: "as-green"
      }, null, 8, ["mainValue", "subTitle"]),
      _createVNode(StaticsItem, {
        title: "Trên 3.5",
        mainValue: getValue('over_35'),
        subTitle: getValue('sub_over_35', true),
        classModify: "as-L"
      }, null, 8, ["mainValue", "subTitle"]),
      _createVNode(StaticsItem, {
        title: "BTTS",
        mainValue: getValue('btts'),
        subTitle: getValue('sub_btts', true)
      }, null, 8, ["mainValue", "subTitle"]),
      _createVNode(StaticsItem, {
        title: "Giữ sạch lưới",
        subTitle: _ctx.footyStats?.home_name,
        mainValue: _ctx.footyStats?.h2h.betting_stats.clubACSPercentage || 0
      }, null, 8, ["subTitle", "mainValue"]),
      _createVNode(StaticsItem, {
        title: "Giữ sạch lưới",
        subTitle: _ctx.footyStats?.away_name,
        mainValue: _ctx.footyStats?.h2h.betting_stats.clubBCSPercentage || 0,
        classModify: "as-L"
      }, null, 8, ["subTitle", "mainValue"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-previous-results__head" }, [
        _createElementVNode("h4", null, " Kết quả trước đó ")
      ], -1)),
      (previous_matches.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previous_matches.value, (match) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, _toDisplayString(_unref(formatLocalTime)(match.date_unix)), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(PlayerItem, {
                        name: match?.team_a?.full_name || '',
                        img: match?.team_a?.image || ''
                      }, null, 8, ["name", "img"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["as-home-score", {
                                            'as-winner': match.team_a_goals > match.team_b_goals
                                        }])
                          }, _toDisplayString(match.team_a_goals), 3),
                          _cache[2] || (_cache[2] = _createTextVNode(" : ")),
                          _createElementVNode("span", {
                            class: _normalizeClass(["as-away-score", {
                                            'as-winner': match.team_a_goals < match.team_b_goals
                                        }])
                          }, _toDisplayString(match.team_b_goals), 3)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(PlayerItem, {
                        name: match?.team_b?.full_name || '',
                        img: match?.team_b?.image || ''
                      }, null, 8, ["name", "img"])
                    ])
                  ])
                ])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})